const validName = (input, minLength = 2) => {
  return (
    new RegExp(/^([^0-9]*)$/).test(input) && input.trim().length >= minLength
  )
}

export default validName
